<template>
  <CFooter :fixed="false">
    <div>
      <a href="https://latinoseguros.com.mx" target="_blank">Framework</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}}.</span>
    </div>
    <div class="mfs-auto">
      <span class="mr-1" target="_blank">Powered by</span>
      <a href="https://latinoseguros.com.mx">Latino Seguros</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
